import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export const validateDate = (startOn: string, endOn: string) => {
  if (stringToDate(endOn, 'backend') <= stringToDate(startOn, 'backend')) {
    return i18n.t('performance_goals.key_results_validations.must_end_later')
  }
}

export const validateTitle = (title: string) => {
  if (title.length === 0) {
    return i18n.t('performance_goals.key_results_validations.title_cant_be_empty')
  }
}

export const validateGoalExistence = (metricGroupId?: string | null) => {
  if (!metricGroupId) {
    return i18n.t('performance_goals.key_results_validations.goal_cant_be_empty')
  }
}

export const validateAssignee = (assigneeId?: string | null) => {
  if (!assigneeId) {
    return i18n.t('performance_goals.key_results_validations.assignee_cant_be_empty')
  }
}

export const validateEmployeeSelection = (
  employeeSelection: EmployeeSelectorV2MultiSelectState
) => {
  if (employeeSelection.type === 'manual' && !employeeSelection.ids.length) {
    return i18n.t('performance_goals.key_results_validations.assignee_cant_be_empty')
  }
}
